import { socket } from "../index";

const emitCheckRoomPassword = (
  roomId: string,
  password: string,
) => {
  socket?.emit('CHECK_ROOM_PASSWORD', { 
    roomId, 
    password,
  });
}

export default emitCheckRoomPassword;